import { render, staticRenderFns } from "./HolidayDialog.vue?vue&type=template&id=3dfde8c5&scoped=true"
import script from "./HolidayDialog.vue?vue&type=script&lang=js"
export * from "./HolidayDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfde8c5",
  null
  
)

export default component.exports